import { parsePricingExpression } from './pricingExpression';
export const PRICING_NUMBERS = ['SmallNetMultiplier', 'SmallOverheadMultiplier', 'SmallLaborAdder', 'SmallLaborMultiplier'];
export const emptyPricingFormula = () => ({
  FormulaType: 'Small Station', MasterStationId: '',
  Formula: '=(((((List Price)*(SmallLaborMultiplier))+(SmallLaborAdder))*(SmallOverHeadMultiplier))+((Sum of Options)/2.5))*(SmallNetMultiplier)+(Setup Multiplier Amount)',
  SmallNetMultiplier: 1.42, SmallOverheadMultiplier: 2.85, SmallLaborAdder: 0, SmallLaborMultiplier: 0.04,
});
export function normalizePricingFormula(row) {
  return Object.fromEntries(['Id', ...Object.keys(emptyPricingFormula())].map(key => [key, row[key] ?? row[key[0].toLowerCase() + key.slice(1)] ?? '']));
}
export function buildPricingFormulaPayload(draft, rows, stations) {
  const payload = { FormulaType: String(draft.FormulaType).trim(), Formula: String(draft.Formula).trim(), MasterStationId: Number(draft.MasterStationId) };
  if (draft.Id) payload.Id = Number(draft.Id);
  if (!stations.some(station => Number(station.id) === payload.MasterStationId)) throw new Error('Choose a station type.');
  if (!payload.FormulaType || !payload.Formula) throw new Error('Formula type and formula text are required.');
  parsePricingExpression(payload.Formula);
  if (rows.some(row => Number(row.MasterStationId) === payload.MasterStationId && Number(row.Id) !== payload.Id)) throw new Error('This station already has a pricing formula. Edit its existing formula instead.');
  for (const key of PRICING_NUMBERS) {
    const value = draft[key];
    if (value == null || String(value).trim() === '' || !Number.isFinite(Number(value)) || Number(value) < 0 || (key === 'SmallNetMultiplier' && Number(value) === 0)) throw new Error(`${key} must be ${key === 'SmallNetMultiplier' ? 'greater than zero' : 'zero or greater'}.`);
    payload[key] = Number(value);
  }
  return payload;
}
